import { AddLink } from '@interhyp/platform-icons';
import prependHttp from 'prepend-http';
import React, { useCallback, useRef, useState } from 'react';
import { TooltipToolbarItem } from "./TooltipToolbarItem.js";
import { LinkCreationForm } from "./components/LinkCreationForm.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function AddLinkToolbarItem({
  on = false,
  title,
  getName,
  getHref,
  onUpdateLink,
  onRemoveLink,
  onAddLink
}) {
  const [href, setHref] = useState('');
  const [name, setName] = useState('');
  const [open, setOpen] = useState(false);
  const nameRef = useRef(null);
  const hrefRef = useRef(null);
  const handleClick = useCallback(() => {
    if (open) {
      return;
    }
    const initialHref = getHref();
    const initialName = getName();
    setTimeout(() => {
      if (initialName) {
        hrefRef.current?.focus();
      } else {
        nameRef.current?.focus();
      }
    }, 1);
    setHref(initialHref ?? '');
    setName(initialName ?? '');
    setOpen(true);
  }, [open, getName, getHref]);
  const onAdd = useCallback(() => {
    const validHref = prependHttp(href);
    if (on) {
      onUpdateLink({
        href: validHref,
        name
      });
    } else {
      onAddLink({
        href: validHref,
        name
      });
    }
    setOpen(false);
  }, [href, name, on, onUpdateLink, onAddLink]);
  const onRemove = useCallback(() => {
    onRemoveLink();
    setOpen(false);
  }, [onRemoveLink]);
  return /*#__PURE__*/_jsx(TooltipToolbarItem, {
    label: on ? 'Link bearbeiten' : 'Link hinzufügen',
    title: title,
    open: open,
    action: handleClick,
    on: on,
    icon: AddLink,
    onClose: () => setOpen(false),
    children: /*#__PURE__*/_jsx(LinkCreationForm, {
      isAlreadyLink: on,
      name: name,
      href: href,
      onNameChange: setName,
      onHrefChange: setHref,
      onAdd: onAdd,
      onRemove: onRemove,
      nameRef: nameRef,
      hrefRef: hrefRef
    })
  }, "link");
}